export { createMedicRequest } from './createMedicRequest'
export { sendProcedureRequest } from './sendProcedureRequest'
export { getTreatmentStatus }  from './getTreatmentStatus'

